import identity from 'lodash-es/identity'
import { ForwardedRef, forwardRef, ReactNode } from 'react'
import { LuEllipsisVertical } from 'react-icons/lu'

import styles from './AsideListItem.module.css'

export type AsideListItemProps = {
  header: ReactNode
  footer: ReactNode
  icon: ReactNode
  actions?: {
    label: ReactNode
    onClick: () => void
  }[]
  customAction?: ReactNode
  onClick?: () => void
  active?: boolean
  className?: string
}

export const AsideListItemRender = (
  {
    header,
    footer,
    icon,
    actions,
    onClick,
    active = false,
    customAction,
    className,
  }: AsideListItemProps,
  ref: ForwardedRef<HTMLLIElement>,
) => {
  return (
    <li ref={ref}>
      <div
        onClick={onClick}
        role="button"
        className={[styles.listItem, active ? styles.active : '', className]
          .filter(identity)
          .join(' ')}
      >
        <div className={styles.header}>{header}</div>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.footer}>{footer}</div>
        <div className={styles.actionsContainer}>
          {customAction && <div className={styles.customAction}>{customAction}</div>}
          <div
            className={styles.actions}
            onClick={(e) => e.stopPropagation()}
            role="button"
            aria-label={'more-options'}
            tabIndex={0}
          >
            <LuEllipsisVertical size={24} strokeWidth={1.8} />
            <div className={styles.moreOptions}>
              <div className={styles.moreOptionsList}>
                {actions?.map((v, i) => (
                  <div className={styles.moreOptionsListItem} onClick={v.onClick} key={i}>
                    {v.label}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}
export const AsideListItem = forwardRef(AsideListItemRender)
export default AsideListItem
